import { httpClient2 } from 'src/infrastructure/admi-client/http-client';

import { PvAnalysisVariationBuilding } from './pv-analysis.dto';
import { RoofSegmentSolarPotential, SolarPotentialSourceType } from './pv-solar-potentials.dto';

export interface SolarPotentialSearch {
    building: PvAnalysisVariationBuilding;
    sourceType: SolarPotentialSourceType;
}

export const admiSolarPotentialsService = {
    async loadSolarPotentials(search: SolarPotentialSearch): Promise<RoofSegmentSolarPotential[]> {
        const response = await httpClient2.post<RoofSegmentSolarPotential[]>(
            `/v1/potential-analysis/solar-potentials`,
            {
                envelopeGeometry: search.building.geometry,
                sourceType: search.sourceType,
            },
        );

        return response.data;
    },
};
